import { useEffect, useRef } from "react"

export const useOnClickOutside = (elementRef, callBack) => {
  const callbackRef = useRef(callBack)

  // Обновляем ref при изменении callback
  useEffect(() => {
    callbackRef.current = callBack
  }, [callBack])

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (elementRef.current && !elementRef.current.contains(event.target)) {
        callbackRef.current()
      }
    };

    const handleEscape = (event) => {
      if (event.key === 'Escape') {
        callbackRef.current()
      }
    };

    document.addEventListener('mousedown', handleOutsideClick)
    document.addEventListener('keydown', handleEscape)

    return () => {
      document.removeEventListener('mousedown', handleOutsideClick)
      document.removeEventListener('keydown', handleEscape)
    }
  }, [elementRef])
}